import { render } from "./DetailsRecommandations.vue?vue&type=template&id=b769bc08&scoped=true"
import script from "./DetailsRecommandations.vue?vue&type=script&lang=js"
export * from "./DetailsRecommandations.vue?vue&type=script&lang=js"

import "./DetailsRecommandations.vue?vue&type=style&index=0&id=b769bc08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b769bc08"]])

export default __exports__